module.exports = __webpack_public_path__ + "img/asset_LDO.71ca03d3.svg";